import { SecondaryBtn, SvgLink } from '@tmapy/style-guide';

import './LinkTooltip.scss';
import { useState } from 'react';

type LinkTooltipProps = {
  title: string;
  description: string;
  onClick(e: React.MouseEvent): void;
};

export const LinkTooltip: React.FC<LinkTooltipProps> = (props) => {
  const [isTooltipHidden, setIsTooltipHidden] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    props.onClick(e);
    setIsTooltipHidden(true);
    setTimeout(() => setIsTooltipHidden(false), 2000);
  };

  const handleMouseLeave = () => {
    if (isTooltipHidden) {
      setIsTooltipHidden(false);
    }
  };

  return (
    <div
      className={`link-tooltip--wrapper ${isTooltipHidden ? 'force-hide' : ''}`}
      onMouseLeave={handleMouseLeave}
    >
      <SecondaryBtn size="sml" icon={{ element: <SvgLink /> }} onClick={handleClick} />

      <div className='link-tooltip--body'>
        <div className='link-tooltip--header'>{props.title}</div>
        <div className='link-tooltip--meta'>
          <span className='link-tooltip--description'>{props.description}</span>
        </div>
      </div>
    </div>
  );
};
